import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '25ch',
    },
    // control: {
    //     margin: '20px 0 40px 0',
    //     padding: theme.spacing(2),
    //     minWidth: 120,
    // },
    // addressDetail: {
    //     padding: '10px 20px',
    // },
    labelArea: {
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    label: {
        marginBottom: '20px',
        color: '#717171',
        [theme.breakpoints.up('xs')]: {
            fontSize: '15px',
        },
    },
    helpText: {
        fontWeight: 'bold',
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginLeft: '0',
        padding: '10px 0',
        background: 'repeating-linear-gradient( -55deg, #FFE7E7 5px, #FFE7E7 10px, #ffffff 10px, #ffffff 20px)'
    },
    required: {
        color: 'red',
    },
    textArea: {
        height: '144px!important',
        [theme.breakpoints.down('sm')]: {
            height: '60px!important',
        },
    },
    // PeAddressFields.js
    // PeAddressFields_control: {
    //     margin: '40px 0 30px 0',
    //     padding: theme.spacing(2),
    // },
    // PeAddressFields_icon: {
    //     color: theme.palette.text.secondary,
    //     paddingRight: '5px',
    // },
    // label: {
    //     marginBottom: '20px',
    //     color: '#787682',
    //     [theme.breakpoints.up('xs')]: {
    //         fontSize: '15px',
    //     },
    // },
    // helpText: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     justifyContent: 'flex-start',
    //     alignItems: 'center',
    //     margin: '10px 0 0 0',
    // },
    // required: {
    //     color: 'red',
    // },
    autocomplete: {
        margin: 0,
        padding: 0,
        fontSize: '18px',
        [theme.breakpoints.up('xs')]: {
            fontSize: '15px',
        },
    },
    autocomplete_dropdown_container: {
        position: 'absolute',
        zIndex: 1000,
    },
    suggestion: {
        cursor: 'pointer',
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
    },
    addressDetail: {
        padding: '30px 0',
    },
    // labelArea: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     alignItems: 'center',
    //     justifyContent: 'flex-start',
    // },
    iconHelp: {
        width: '25px',
        height: '25px',
        margin: '-5px 0 0 10px',
        color: theme.palette.primary.main,
        '&:hover': {
            cursor: 'pointer',
        },
    },
    input: {
        fontSize: '16px',
        [theme.breakpoints.up('xs')]: {
            fontSize: '15px',
        },
    },
    extraControl: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        fontSize: '0.85rem',
        margin: '0 0 15px 0',
        padding: '0 16px',
        [theme.breakpoints.down('sm')]: {
            padding: '0 8px',
            justifyContent: 'flex-start',
            margin: '15px 0',
        },
    },
    //PEButton
    // PEButton_button: {
    //     padding: '20px',
    //     border: 'none',
    //     borderRadius: '30px',
    //     width: '100%',
    //     fontSize: '15px',
    //     fontWeight: 500,
    //     transition: '0.1s',
    //     '&:hover': {
    //         transform: 'scale(1.1, 1.1)',
    //     },
    //     [theme.breakpoints.down('sm')]: {
    //         '&:hover': {
    //             transform: 'none',
    //         },
    //     },
    // },
    over: {
        backgroundImage: 'linear-gradient(to right,#868f96 0,#596164 100%)',
        color: 'white',
        cursor: 'pointer',
    },
    prev: {
        backgroundImage: 'linear-gradient(135deg,#dae1ff 0,#fbf6ff 100%)',
        color: 'gray',
        cursor: 'pointer',
    },
    // PeButton_active: {
    //     backgroundImage: 'linear-gradient(135deg,#667eea 0,#764ba2 100%)',
    //     color: 'white',
    //     cursor: 'pointer',
    // },
    disabled: {
        backgroundColor: 'white',
        color: '#D3D3D3',
        boxShadow: '0px 1px 15px 6px rgba(0,0,0,0.08)',
        cursor: 'not-allowed',
    },
    normalBtn: {
        backgroundImage: 'linear-gradient(135deg ,#d8d8d8 0,#b9b9b9 100%);',
        color: '#616161',
    },
    //PeButtonControl
    appbar: {
        backgroundColor: 'white',
        boxShadow: 'none',
        borderTop: '1px solid #EBEBEB',
        color: '#787682',
        position: 'relative',
        padding: '15px 0 5px 0',
        top: 'auto',
        bottom: 0,
    },
    PeButtonControl_control: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '10px auto',
    },
    //PeDetailInfo
    // PeDetailInfo_control: {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     flexWrap: 'nowrap',
    //     alignContent: 'center',
    //     justifyContent: 'flex-start',
    //     alignItems: 'center',
    //     padding: '10px',
    //     [theme.breakpoints.down('sm')]: {
    //         marginTop: '80px',
    //     },
    // },
    paper: {
        width: '100%',
        marginTop: '10px',
        padding: '10px',
    },
    preview: {
        height: '',
    },
    customer: {
        margin: '5px 0 15px 0',
        padding: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: '#787682',
    },
    icon: {
        marginRight: '5px',
        width: '20px',
        height: '20px',
        [theme.breakpoints.up('xs')]: {
            width: '15px',
            height: '15px',
        },
    },
    // PeDetailInfo_text: {
    //     margin: 0,
    //     padding: '5px 2px',
    //     color: '#9F9F9F',
    // },
    value: {
        margin: 0,
        padding: '4px 2px',
        color: theme.palette.primary.light,
        fontWeight: 'bold',
        whiteSpace: 'pre-line',
        lineHeight: '1.3rem',
    },
    // previewLine: {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     justifyContent: 'space-between',
    //     alignItems: 'flex-start',
    //     borderTop: '3px solid #F9F9F9',
    //     '&:nth-first-child': {
    //         borderTop: 'none',
    //     },
    // },
    accordion: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: theme.palette.text.secondary,
    },
    titlePart: {
        fontSize: '18px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '15px',
        },
    },
    nopadding: {
        padding: '0',
    },
    //PeDialog
    PeDialog_header: {
        borderBottom: '1px solid #9F9F9F',
        color: theme.palette.primary.main,
    },
    PeDialog_content: {
        margin: '20px 0',
    },
    button: {
        fontFamily: 'Roboto, sans-serif',
        fontSize: '14px',
        fontWeight: 500,
        marginLeft: '10px',
    },
    //PeDrawerMenu
    WrapperDrawer: {
        width: '320px',
    },
    PeDrawerMenu_button: {
        borderWidth: '2px',
        borderStyle: 'solid',
        fontSize: '1em',
        fontFamily: 'Oswald',
        fontWeight: 'normal',
    },
    wrapPadding: {
        position: 'relative',
        height: '100%',
    },
    paddingButton: {
        display: 'flex',
        padding: '10px',
        'flex-direction': 'row',
        'align-items': 'center',
        'justify-content': 'space-between',
        position: 'fixed',
        background: 'white',
        width: '310px',
        'z-index': '1000',
    },
    bottomItem: {
        fontSize: '12px',
        textAlign: 'center',
        position: 'absolute',
        bottom: '0px',
        left: '0px',
        width: '100%',
    },
    itemStyle: {
        background: '#e6e6e6',
    },
    //PeExtraField
    PeExtraField_control: {
        padding: theme.spacing(2),
    },
    table: {
        fontSize: '14px',
        boxShadow: 'none',
        border: '1px solid #CECECE',
        borderRadius: '6px',
    },
    unselectable: {
        userSelect: 'none',
    },
    margin: {
        margin: theme.spacing(1),
    },
    amountInput: {
        padding: '10px',
        fontSize: '15px',
        width: '50%',
    },
    //PeInput
    // label: {
    //     marginBottom: '20px',
    //     color: '#787682',
    //     [theme.breakpoints.up('xs')]: {
    //         fontSize: '15px',
    //     },
    // },
    // input: {
    //     fontSize: '16px',
    //     [theme.breakpoints.up('xs')]: {
    //         fontSize: '15px',
    //     },
    // },
    // helpText: {
    //     fontWeight: 'bold',
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     justifyContent: 'flex-start',
    //     alignItems: 'center',
    //     marginLeft: '0',
    // },
    // required: {
    //     color: 'red',
    // },
    //PeMoreInfo
    PeMoreInfo_control: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        padding: '20px',
        borderRadius: '5px',
        fontStyle: 'italic',
        color: '#565656',
        fontSize: '14px',
        whiteSpace: 'pre-line',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        lineHeight: '1.3rem',
    },
    PeMoreInfo_info: {
        backgroundColor: '#cce5fb',
        borderLeft: '5px solid #6ca7e4',
    },
    warn: {
        backgroundColor: '#ffe1e1',
        borderLeft: '5px solid #f98a8a',
    },
    notice: {
        borderLeft: '5px solid #ffc107',
        backgroundColor: '#fbeacc',
    },
    buttonArea: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        marginTop: '15px',
    },
    PeMoreInfo_button: {
        background:
            'linear-gradient(130deg,rgba(246,153,81,1) 0,#ff7745 100%,rgba(255,255,255,1) 100%)',
        padding: '15px 30px',
        boxShadow: 'none',
        borderRadius: '10px',
        color: 'white',
        textTransform: 'none',
        fontSize: 'inherit',
    },
    //PePersonalise
    // controlImg: {
    //     margin: '20px 0 40px 0',
    //     padding: theme.spacing(2),
    //     background: 'linear-gradient(130deg,#e0dbfb 0,white 100%,white 100%)',
    //     borderRadius: '5px',
    // },
    paddingBackground: {
        margin: '15px -12px',
        padding: '10px 12px 20px 10px',
        background: '#f9f9f9',
    },
    PePersonalise_label: {
        color: '#717171',
        [theme.breakpoints.up('xs')]: {
            fontSize: '15px',
        },
    },
    PePersonalise_labelArea: {
        padding: '0 16px',
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    //PePricingOption
    // PePricingOption_control: {
    //     margin: '20px 0 40px 0',
    //     display: 'block',
    //     padding: theme.spacing(2),
    // },
    // label: {
    //     color: '#717171',
    //     [theme.breakpoints.up('xs')]: {
    //         fontSize: '15px',
    //     },
    // },
    // helpText: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     justifyContent: 'flex-start',
    //     alignItems: 'center',
    //     margin: '10px 0 0 0',
    // },
    // labelArea: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     alignItems: 'center',
    //     justifyContent: 'flex-start',
    // },
    // iconHelp: {
    //     width: '30px',
    //     height: '30px',
    //     marginLeft: '10px',
    //     color: theme.palette.primary.main,
    //     '&:hover': {
    //         cursor: 'pointer',
    //     },
    // },
    // required: {
    //     color: 'red',
    // },
    PePricingOption_paper: {
        margin: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.secondary,
        boxShadow: 'none',
        border: '1px solid #cecece',
        '&:hover': {
            cursor: 'pointer',
        },
        minHeight: '200px',
    },
    PeWaterWarning: {
        background: '#ffe1e1',
    },
    PeWaterAccept: {
        background: '#d1f3d3',
    },
    PePricingOption_active: {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
    },
    sandenName: {
        fontFamily: 'Oswald',
        textAlign: 'center',
    },
    media: {
        height: 200,
    },
    iconArea: {
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '10px 0 20px 0',
    },
    info: {
        fontSize: '15px',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'space-between',
        lineHeight: '1.3rem',
    },
    infoIcon: {
        padding: '0 3px 2px 0',
        width: '20px',
        height: '20px',
    },
    count: {
        fontFamily: 'Oswald',
        fontSize: '30px',
        color: 'inherit',
        margin: '10px 0',
        padding: 0,
    },
    actionActive: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
    },
    header: {
        width: 'calc(100% - 32px)',
        borderBottom: '1px dashed #CECECE',
        margin: '0 0 10px 0',
    },
    spread: {
        width: 'calc(100% - 32px)',
        height: '1px',
        borderTop: '1px dashed #CECECE',
        margin: '10px 0',
    },
    line: {
        width: 'calc(100% - 32px)',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        fontSize: '14px',
        textAlign: 'justify',
    },
    priceLine: {
        width: 'calc(100% - 32px)',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        fontSize: '14px',
        textAlign: 'justify',
    },
    lineLeft: {
        padding: '0 20px 0 0',
        minWidth: '25px',
        margin: '5px 0',
    },
    totalPrice: {
        width: 'calc(100% - 32px)',
        fontFamily: 'Oswald',
        textAlign: 'center',
        marginTop: '16px',
        color: '#717171',
    },
    //PeSelectBox
    // control: {
    //     padding: theme.spacing(2),
    //     margin: '20px 0 40px 0',
    // },
    // label: {
    //     marginBottom: '20px',
    //     color: '#787682',
    //     [theme.breakpoints.up('xs')]: {
    //         fontSize: '15px',
    //     },
    // },
    // helpText: {
    //     fontWeight: 'bold',
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     justifyContent: 'flex-start',
    //     alignItems: 'center',
    //     marginLeft: '0',
    // },
    // required: {
    //     color: 'red',
    // },
    //PeSingleChoice
    control: {
        margin: '20px 0 40px 0',
        // display: 'block',
        padding: theme.spacing(2),
        [theme.breakpoints.up('xs')]: {
            margin: '0',
        },
    },
    // label: {
    //     color: '#717171',
    //     [theme.breakpoints.up('xs')]: {
    //         fontSize: '15px',
    //     },
    // },
    // helpText: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     justifyContent: 'flex-start',
    //     alignItems: 'center',
    //     margin: '10px 0 0 0',
    // },
    // required: {
    //     color: 'red',
    // },
    PeSingleChoice_paper: {
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        boxShadow: 'none',
        border: '1.5px solid #cecece',
        [theme.breakpoints.up('md')]: {
            '&:hover': {
                backgroundColor: theme.palette.primary.light,
                color: 'white',
                cursor: 'pointer',
            },
        },
    },
    active: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        cursor: 'pointer',
        fill: 'white',
    },
    optImg: {
        margin: 0,
        padding: '0 20px 0 0',
        width: '40px',
        height: '40px',
    },
    optDetail: {
        '&Label': {
            fontSize: '18px',
            margin: 0,
            padding: 0,
        },
        '&SubLabel': {
            fontSize: '12px',
            fontWeight: '100',
            fontStyle: 'italic',
            margin: 0,
            padding: 0,
        },
        [theme.breakpoints.up('xs')]: {
            '&Label': {
                fontSize: '15px',
            },
        },
    },
    // labelArea: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     alignItems: 'center',
    //     justifyContent: 'flex-start',
    // },
    // iconHelp: {
    //     width: '25px',
    //     height: '25px',
    //     margin: '-5px 0 0 10px',
    //     color: theme.palette.primary.main,
    //     '&:hover': {
    //         cursor: 'pointer',
    //     },
    // },
    controlImg: {
        margin: '20px 0 40px 0',
        display: 'block',
        padding: theme.spacing(2),
        background: 'linear-gradient(130deg,#fff1da 0,white 100%,white 100%)',
        borderRadius: '5px',
    },
    optionIcon: {
        'justify-content': 'flex-start',
    },
    //PeStep
    PeStep_control: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        height: '100%',
    },
    area: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'flex-end',
        margin: '0 auto',
        height: '70%',
        borderRight: '1px solid #ececec',
        width: 'fit-content',
    },
    item: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        textAlign: 'right',
        margin: '30px -20px 0 0',
    },
    itemMain: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'flex-end',
        textAlign: 'right',
    },
    itemInfo: {
        marginRight: '10px',
    },
    itemProgress: {
        fontSize: '0.9em',
        margin: 0,
        padding: 0,
        display: 'block',
    },
    itemName: {
        margin: 0,
        padding: 0,
        fontSize: '1.17em',
    },
    itemSub: {
        width: '10px',
        height: '10px',
        backgroundColor: '#D3D3D3',
        borderRadius: '5px',
        margin: '30px 15px 0 0',
    },
    colorGray: {
        color: '#9F9F9F',
    },
    PeStep_icon: {
        transition: '0.1s',
        background: 'white',
        height: '40px',
        width: '40px',
        borderRadius: '20px',
        margin: 0,
        padding: 0,
        '&:hover': {
            transform: 'scale(1.2, 1.2)',
            cursor: 'pointer',
        },
    },
    //PeSubsidy
    // control: {
    //     margin: '20px 0 40px 0',
    //     display: 'block',
    //     padding: theme.spacing(2),
    // },
    // table: {
    //     fontSize: '14px',
    //     boxShadow: 'none',
    //     border: '1px solid #CECECE',
    //     borderRadius: '6px',
    // },
    // PeSubsidy_unselectable: {
    //     userSelect: 'none',
    //     alignItems: 'flex-start',
    // },
    // margin: {
    //     margin: theme.spacing(1),
    // },
    // amountInput: {
    //     padding: '10px',
    //     fontSize: '15px',
    //     width: '80px',
    // },
    // labelArea: {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     alignItems: 'center',
    //     justifyContent: 'flex-start',
    // },
    // iconHelp: {
    //     width: '30px',
    //     height: '30px',
    //     marginLeft: '10px',
    //     color: theme.palette.primary.main,
    //     '&:hover': {
    //         cursor: 'pointer',
    //     },
    // },
    // label: {
    //     color: '#717171',
    //     [theme.breakpoints.up('xs')]: {
    //         fontSize: '15px',
    //     },
    // },
    // PeSubsidy_button: {
    //     margin: '0 10px 10px 0',
    // },
    //PeSummary
    // control: {
    //     padding: theme.spacing(2),
    // },
    PeSummary_table: {
        fontSize: '14px',
        boxShadow: 'none',
        border: '1px solid #CECECE',
        borderRadius: '6px',
    },
    // unselectable: {
    //     userSelect: 'none',
    // },
    // margin: {
    //     margin: theme.spacing(1),
    // },
    total: {
        fontSize: '22px',
        fontFamily: 'Oswald',
    },
    productInfo: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    productName: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        color: '#787682',
    },
    PeSummary_icon: {
        marginLeft: '5px',
        cursor: 'pointer',
        fontSize: '20px',
    },
    productDesc: {
        marginTop: '10px',
        fontSize: '0.9em',
        fontStyle: 'italic',
        color: '#9F9F9F',
        textAlign: 'justify',
        whiteSpace: 'pre-line',
    },
    gst: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        alignContent: 'center',
    },
    //PeTextArea
    // control: {
    //     padding: theme.spacing(2),
    // },
    // label: {
    //     marginBottom: '20px',
    //     color: '#717171',
    // },
    //PeThankyouPage
    PeThankYouPage_control: {
        padding: '100px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
    },
    thankyou: {
        fontSize: '5em',
        fontFamily: 'Oswald',
        margin: '0 0 20px 0',
        [theme.breakpoints.down('sm')]: {
            fontSize: '2em',
        },
    },
    text: {
        fontSize: '20px',
        textAlign: 'center',
    },
    logo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
    },
    iconPartner: {
        width: '250px',
        [theme.breakpoints.down('sm')]: {
            width: '150px',
        },
    },
    //PeTopBar
    PeTopBar_appbar: {
        backgroundColor: 'white',
        boxShadow: 'none',
        borderBottom: '1px solid #EBEBEB',
        color: '#787682',
        position: 'relative',
        padding: '5px 0',
        [theme.breakpoints.down('sm')]: {
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
        },
    },
    PeTopBar_logo: {
        height: '50px',
    },
    title: {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    titleText: {
        fontFamily: 'Oswald',
        color: '#1178AB'
    },
    mode: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    PeTopBar_button: {
        borderWidth: '2px',
        borderStyle: 'solid',
        fontSize: '1em',
        fontFamily: 'Oswald',
        fontWeight: 'normal',
    },
    rightItem: {
        textAlign: 'right',
    },
    logoMobile: {
        height: '45px',
    },
    centerItem: {
        'flex-wrap': 'wrap',
        'box-sizing': 'border-box',
        'flex-direction': 'row',
        'align-content': 'center',
        'justify-content': 'space-around',
        'align-items': 'center',
    },
    //PePDFContent
    content: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: '1.1rem',
    },
    PePDFContent_table: {
        fontSize: '10px',
        bordeSpacing: '0px',
        borderCollapse: 'collapse',
        textAlign: 'justify',
    },
    headCell: {
        backgroundColor: '#B0C5DE',
        fontWeight: 'bold',
        padding: '0 5px',
        fontSize: 'inherit',
        verticalAlign: 'middle',
    },
    cell: {
        padding: '0 5px',
        fontSize: 'inherit',
        verticalAlign: 'middle',
        whiteSpace: 'pre-line',
    },
    leftBottom: {
        borderBottom: '1px solid #000',
        borderLeft: '1px solid #000',
    },
    PePDFContent_right: {
        borderRight: '1px solid #000',
    },
    top: {
        borderTop: '1px solid #000',
    },
    bottomArea: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '10px',
        width: '100%',
    },
    result: {
        width: '100%',
        margin: 0,
        padding: 0,
        fontSize: '11px',
    },
    resultRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
    },
    //PePDFHeader
    PePDFHeader_control: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        lineHeight: '1.1rem',
    },
    //Login
    app: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        backgroundColor: '#EBEDF7',
        height: '100vh',
    },
    Login_paper: {
        width: '700px',
        maxWidth: '90%',
        height: '500px',
        borderRadius: '30px',
        boxShadow: 'none',
    },
    Login_control: {
        width: 'calc(100% - 50px)',
    },
    // label: {
    //     marginBottom: '10px',
    //     color: '#787682',
    // },
    // helpText: {
    //     fontWeight: 'bold',
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignContent: 'center',
    //     justifyContent: 'flex-start',
    //     alignItems: 'center',
    //     marginLeft: '0',
    // },
    // required: {
    //     color: 'red',
    // },
    headerTxt: {
        padding: '10px 25px',
        margin: '40px 0 10px 0',
        fontFamily: 'Oswald',
    },
    Login_button: {
        padding: '25px',
        margin: '20px 0',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '0 25px',
        },
    },
    left: {
        backgroundColor: '#D7DAEB',
        minHeight: '100%',
        borderTopLeftRadius: '30px',
        borderBottomLeftRadius: '30px',
        display: 'flex',
    },
    nav: {
        width: '700px',
        maxWidth: '90%',
        cursor: 'pointer',
    },
    //SandenForm
    SandenForm_control: {
        padding: theme.spacing(2),
        margin: '20px auto 0 auto',
    },
    SandenForm_button: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    //SandenFormWorkspace
    SandenFormWorkspace_app: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
            paddingTop: '50px',
        },
    },
    main: {
        overflow: 'hidden',
        backgroundColor: '#F9F9FC',
    },
    form: {
        display: 'block',
        height: 'calc(100vh - 55px)',
        overflowY: 'scroll',
        overflowX: 'hidden',
        backgroundColor: 'white',
        boxShadow: '0px 0px 6px -1px rgba(0,0,0,0.1)',
    },
    SandenFormWorkspace_left: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    right: {
        display: 'block',
        height: 'calc(100vh - 55px)',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    isBottom: {
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '20px',
        left: 'calc(50vw - 100px)',
        width: '200px',
        transition: 'display 1s ease-in-out',
        opacity: 0.2,
        '&:hover': {
            opacity: 1,
            cursor: 'pointer',
        },
    },
    isBottomItem: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        justifyItems: 'center',
        backgroundColor: '#2e2e2e',
        color: 'white',
        padding: '14px 10px',
        borderRadius: '15px',
        fontSize: '14px',
    },
    SandenFormWorkspace_icon: {
        width: '25px',
        height: '25px',
    },
    PeUpload_button: {
        backgroundColor: '#3AA2DB',
        color: 'white',
        border: '2px solid #3AA2DB',
        boxShadow: 'none',
    },
    //PeLoading
    // backdrop: {
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyItems: 'center',
    //     flexDirection: 'column',
    //     zIndex: theme.zIndex.drawer + 1,
    //     color: '#fff',
    // },
    //PeImage
    lazyImage: {
        opacity: 1,
        transition: 'opacity 0.1s ease-in-out',
        borderRadius: '5px',
        width: '100%',
        background: 'white',
    },// PeProductChoice
    PePrdChoice_text: {
        marginBottom: 10, 
        color: '#9F9F9F', 
        fontSize: '13px'
    },
    PePrdChoice_extra: {
        marginBottom: 10, 
        marginRight: 10, 
        color: '#9F9F9F', 
        fontSize: '13px',
        display: 'inline-block',
    },
    // PeInstallationDialog
    PeInstallationDialog_text: {
        marginRight: 10,
        marginBottom: 10,
        cursor: 'pointer'
    }
}));

export default useStyles;
